/** @format */
import { JDNetwork } from '@jdreact/jdreact-core-lib';

const fetch = (functionId: string, params: string): Promise<any> => {
  const timeoutPromise = new Promise((resolve, reject) => {
    setTimeout(() => {
      reject();
    }, 10000);
  });
  return Promise.race([JDNetwork.fetchWithoutHost(functionId, params, 'get'), timeoutPromise]);
};

export { fetch };
